import { motion } from "framer-motion";
import { CheckCircle2, XCircle, AlertTriangle, Info, X } from "lucide-react";
import { toastVariant } from "@styles/motion";

/**
 * Toast — a single notification. Rendered by <ToastContainer />, which
 * reads the active list from UIContext. Not meant to be used standalone.
 */
const TONE = {
  success: { icon: CheckCircle2, className: "text-brand-success" },
  error: { icon: XCircle, className: "text-brand-danger" },
  warning: { icon: AlertTriangle, className: "text-brand-gold" },
  info: { icon: Info, className: "text-brand-primary" },
};

export default function Toast({ message, type = "info", onDismiss }) {
  const { icon: Icon, className } = TONE[type] ?? TONE.info;

  return (
    <motion.div
      layout
      initial={toastVariant.initial}
      animate={toastVariant.animate}
      exit={toastVariant.exit}
      transition={toastVariant.transition}
      className="flex items-center gap-2.5 bg-brand-ink text-white rounded-xl shadow-raised px-4 py-3 max-w-sm w-full"
    >
      <Icon size={18} className={`flex-shrink-0 ${className}`} />
      <p className="text-body-sm font-semibold flex-1">{message}</p>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Yopish"
          className="flex-shrink-0 text-white/60 hover:text-white"
        >
          <X size={14} />
        </button>
      )}
    </motion.div>
  );
}
